import { Text } from '@chakra-ui/react';
import { FaIcon } from '@acp/core-ui';
import { faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { ExperimentLink } from '@acp/feature/auth';
import { Property } from '@acp/shared';
import { ActiveNoticesContactUs } from './active-notices-contact-us';

export function UpdateLeaseDetailsLink({
    property,
    isContactDiRequired = false,
}: {
    property: Property;
    isContactDiRequired?: boolean;
}) {
    if (isContactDiRequired) {
        return (
            <ActiveNoticesContactUs />
        );
    }

    if (property.isIntegrated === true) {
        return (
            <Text fontSize="small" fontWeight="bold" mt={2}>
                Please update your property management software with latest lease details
            </Text>
        );
    }

    return (
        <>
            <Text fontSize="small" mt={2}>Please provide us with updated tenancy information as soon as possible</Text>

            <Text
                as={ExperimentLink}
                experimentName="AgencyCompliancePortalPropertyDetails"
                withExperiment={{
                    isExternal: false,
                    to: `/property/${property.compliancePropertyId}/tenancy`,
                }}
                withoutExperiment={{
                    isExternal: true,
                    to: `/Properties/view/${property.compliancePropertyId}`,
                }}
                fontSize="small"
                fontWeight="bold"
                mt={1}
            >
                Update lease details
                <FaIcon icon={faUpRightFromSquare} ml={1} h={3} />
            </Text>
        </>
    );
}
